module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer007"
    }
  }, [_c('p', {
    staticClass: "FM_FM-head"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_vm._v("x")])]), _vm._v(" "), _c('p', {
    staticClass: "FM_1act"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Activities")]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW1#_idTextAnchor006"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Bibliomancy")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-2-9 ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW2#_idTextAnchor008"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Which Kind of Witch?")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-2-9 ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW6#_idTextAnchor014"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Cooking with Magic")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-2-9 ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW6#_idTextAnchor015"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Planting Herbs")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-2-9 ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW6#_idTextAnchor017"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Creating a Portable Altar")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-2-9 ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW6#_idTextAnchor019"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Spiritual Spring Cleaning")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-2-9 ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW6#_idTextAnchor021"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Bathing Bliss")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-2-9 ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW7#_idTextAnchor025"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Charm Bags and Magic Sachets")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-2-9 ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW7#_idTextAnchor026"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Decorative Plaques")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW7#_idTextAnchor028"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Magic Wands")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW7#_idTextAnchor029"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Don’t Get Rattled")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW8#_idTextAnchor032"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("An Easy Daily Tarot Practice")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW8#_idTextAnchor033"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("A Daily Rune Practice")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW8#_idTextAnchor034"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Dream Pillows")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW9#_idTextAnchor036"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Grounding and Centering")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW9#_idTextAnchor037"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Wind and Weather")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW9#_idTextAnchor039"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("All Fired Up")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW9#_idTextAnchor040"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Power Up Your Water")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW9#_idTextAnchor042"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Using Goddess Oracle Decks")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW9#_idTextAnchor043"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Do Something Nice")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW10#_idTextAnchor046"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Write a Basic Spell")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('span', {
    staticClass: "exercise-toc"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_vm._v("xi")])]), _c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("T")]), _c('a', {
    attrs: {
      "href": "#/LLBW10#_idTextAnchor047"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("o Spell or Not to Spell")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW10#_idTextAnchor050"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Choosing Your Optional Extras")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW10#_idTextAnchor052"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Candle Magic")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW11#_idTextAnchor068"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Making a Poppet")])])]), _vm._v(" "), _c('p', {
    staticClass: "FM_1act"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("Spells")]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW7#_idTextAnchor024"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Crafting Spell")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-2-9 ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW10#_idTextAnchor048"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Deborah’s Classic Prosperity Spell")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-2-9 ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW11#_idTextAnchor056"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Finding Love")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-2-9 ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW11#_idTextAnchor057"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Mending a Relationship")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-2-9 ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW11#_idTextAnchor058"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Full Moon Opening to Love")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-2-9 ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW11#_idTextAnchor059"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Prosperity Spell")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-2-9 ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW11#_idTextAnchor060"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Reducing Debt")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-2-9 ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW11#_idTextAnchor061"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Abundance")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-2-9 ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW11#_idTextAnchor062"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Protection")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW11#_idTextAnchor063"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Calm and Grounding")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW11#_idTextAnchor064"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Cleansing Body and Spirit")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW11#_idTextAnchor065"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Personal Growth")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW11#_idTextAnchor066"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Achieving Goals and Success")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW11#_idTextAnchor067"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Healing the Body")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW11#_idTextAnchor069"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Healing the Spirit")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW11#_idTextAnchor070"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Letting Go")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW11#_idTextAnchor071"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Divination")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('span', {
    staticClass: "exercise-toc"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_vm._v("xii")])]), _c('a', {
    attrs: {
      "href": "#/LLBW11#_idTextAnchor073"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Increasing Psychic Ability")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW11#_idTextAnchor074"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Connecting with Goddess")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW11#_idTextAnchor075"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Connecting with Nature and the Elements")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW11#_idTextAnchor076"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Increase Energy")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW11#_idTextAnchor077"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Depression Banishing")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW11#_idTextAnchor079"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Dreams Come True")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW11#_idTextAnchor080"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Patience")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW11#_idTextAnchor081"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Confidence")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW11#_idTextAnchor082"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Travel Protection")])])]), _vm._v(" "), _c('p', {
    staticClass: "FM_1act"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _vm._v("Tips")]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW2#_idTextAnchor009"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("A Word on the "), _c('br'), _vm._v("Wiccan Rede")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-2-9 ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW6#_idTextAnchor016"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("The Subtle Altar")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-2-9 ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW6#_idTextAnchor018"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Leave the "), _c('br'), _vm._v("World Behind")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-2-9 ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW6#_idTextAnchor020"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Altar Attention")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-2-9 ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW6#_idTextAnchor022"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Car Karma")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-2-9 ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW7#_idTextAnchor027"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Wax Tablets")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-2-9 ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW8#_idTextAnchor031"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Tarot Books")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-2-9 ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW9#_idTextAnchor038"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Fire without Flames")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-2-9 ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW9#_idTextAnchor041"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Dancing "), _c('br'), _vm._v("in the Rain")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW10#_idTextAnchor045"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Free Will")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW10#_idTextAnchor049"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Optional Spell Ending")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW10#_idTextAnchor051"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Representing "), _c('br'), _vm._v("Goddess and God During Ritual and "), _c('br'), _vm._v("on the Altar")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('span', {
    staticClass: "exercise-toc"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_vm._v("xiii")])]), _c('a', {
    attrs: {
      "href": "#/LLBW10#_idTextAnchor053"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Broom Bonuses")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW10#_idTextAnchor054"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Gifts and "), _c('br'), _vm._v("Offerings")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW11#_idTextAnchor072"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("Connecting "), _c('br'), _vm._v("with Goddess")])])]), _vm._v(" "), _c('p', {
    staticClass: "exercises-copy_exercise-toc-10"
  }, [_c('a', {
    attrs: {
      "href": "#/LLBW11#_idTextAnchor078"
    }
  }, [_c('span', {
    staticClass: "exercise-toc _idGenCharOverride-1"
  }, [_vm._v("The Power of "), _c('br'), _vm._v("the Positive")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84a0e794","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Activites.vue
// module id = 69
// module chunks = 0